@for (alertMetadata of alertsMetada$ | async; track $index) {
  <div class="pointer-events-auto rounded-md" [@expandCollapse]>
    @switch (alertMetadata.alertKind) {
      @case ('custom') {
        @if (getCustomAlert(alertMetadata.alert); as alert) {
          <app-alert-custom
            class="max-w-full"
            [alertType]="alert.alertType"
            [component]="alert.component"
            [componentInput]="alert.componentInput"
            [displayCloseBtn]="alert.closeBtn"
            [attr.data-test-id]="alert.id"
            (closeClick)="removeAlert(alertMetadata.id)"
          ></app-alert-custom>
        }
      }

      @case ('text') {
        @if (getTextAlert(alertMetadata.alert); as alert) {
          <app-alert
            class="max-w-full"
            [alertType]="alert.alertType"
            [displayCloseBtn]="alert.closeBtn"
            [attr.data-test-id]="alert.id"
            (closeClick)="removeAlert(alertMetadata.id)"
          >
            <span [innerHTML]="sanitizeRichText(alert.text | translate)"></span>
          </app-alert>
        }
      }

      @case ('actionError') {
        @if (getActionErrorAlert(alertMetadata.alert); as alert) {
          <app-action-error-alert
            [actionTranslationKey]="alert.actionTranslationKey"
            [errorTranslationKey]="alert.errorTranslationKey"
            [objectTranslationKey]="alert.objectTranslationKey"
            [errorBodyTranslationKey]="alert.errorBodyTranslationKey"
            [redirectAction]="alert.redirectAction"
            [objectBodyTranslationKey]="alert.objectBodyTranslationKey"
            [customBaseTranslationKey]="alert.customBaseTranslationKey"
            [attr.data-test-id]="alert.id"
            (closeClick)="removeAlert(alertMetadata.id)"
          ></app-action-error-alert>
        }
      }

      @case ('tryAgainActionError') {
        @if (getTryAgainActionErrorAlert(alertMetadata.alert); as alert) {
          <app-try-again-action-error-alert
            [errorTranslationKey]="alert.errorTranslationKey"
            [tryAgainAction]="alert.tryAgainAction"
            [attr.data-test-id]="alert.id"
            [tryAgainAdditionalTextKey]="alert.tryAgainAdditionalTextKey"
            (closeClick)="removeAlert(alertMetadata.id)"
          ></app-try-again-action-error-alert>
        }
      }

      @case ('undo') {
        @if (getUndoAlert(alertMetadata.alert); as alert) {
          <app-alert-undo
            [alertType]="alert.alertType"
            [text]="alert.text"
            [onUndo]="alert.undoAction"
            [attr.data-test-id]="alert.id"
            (closeClick)="removeAlert(alertMetadata.id)"
          ></app-alert-undo>
        }
      }

      @case ('loading') {
        @if (getLoadingAlert(alertMetadata.alert); as alert) {
          <app-alert-loading
            [text]="alert.text"
            [displayCloseBtn]="alert.closeBtn"
            [attr.data-test-id]="alert.id"
            (closeClick)="removeAlert(alertMetadata.id)"
          ></app-alert-loading>
        }
      }

      @case ('actionSuccess') {
        @if (getActionSuccessAlert(alertMetadata.alert); as alert) {
          <app-action-success-alert
            [actionText]="alert.actionText"
            [successText]="alert.successText"
            [redirectAction]="alert.redirectAction"
            [attr.data-test-id]="alert.id"
            (closeClick)="removeAlert(alertMetadata.id)"
          ></app-action-success-alert>
        }
      }
    }
  </div>
}
